import { captureException } from '@sentry/vue'

export const handleSentryError = (error: Error) => {
  captureException(error)
  console.error(error)
}
